module.exports = __webpack_public_path__ + "img/brush-01.d4846ab9.svg";